var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{class:`${_vm.class_name ? _vm.class_name : 'default-color'} detail-link`,on:{"click":function($event){return _vm.getDetail(_vm.row_id)}}},[_vm._v("\n        "+_vm._s(_vm.row_name)+"\n    ")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }